<template>
  <div class="event-schedule container">
    <div class="event-schedule__header pt-2">
      <div v-if="currentEvent" class="px-2 mb-2">
        <div class="event-schedule__current-event">
          <h2 class="event-schedule__current-event-title">
            {{ currentEvent.title }}
          </h2>
          <v-button round ghost class="mr-0" @click="unchooseEvent">
            <v-icon icon="close" />
          </v-button>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <v-button
            class="event-schedule__nav-button"
            round
            ghost
            @click="change(-1)"
          >
            <v-icon icon="chevron_left" />
          </v-button>
          <h3 class="m-0">
            {{ toDate(shownDate, "MMMM YYYY") }}
          </h3>
        </div>
        <div class="d-flex">
          <v-button
            round
            :disabled="monthsFromNow === 0"
            ghost
            @click="jumpToToday"
            class="mx-0 px-0 event-schedule__jump-to-today"
          >
            <v-icon icon="today" />
          </v-button>
          <v-button
            class="event-schedule__nav-button ml-0"
            round
            ghost
            @click="change(1)"
          >
            <v-icon icon="chevron_right" />
          </v-button>
        </div>
      </div>
    </div>

    <template v-if="isLoading">
      <div class="d-flex justify-content-center p-5">
        <v-loader />
      </div>
    </template>
    <template v-else-if="isPresent(eventsByDay)">
      <div
        v-for="(day, i) in Object.keys(eventsByDay)"
        :key="day"
        class="event-schedule__day"
        :style="{ animationDelay: `${i * 0.05}s` }"
      >
        <div class="event-schedule__date-wrapper mt-2">
          <event-occurrence-date :date="day" no-border />
        </div>
        <collection
          class="pt-0"
          card-display="vertical"
          modifiers="no-image"
          :items="eventsByDay[day]"
          :space-bottom-ratio="150"
          unlock
        />
      </div>
    </template>
    <template v-else>
      <div class="text-center p-5">
        <p class="lead">
          No events scheduled for
          {{ toDate(shownDate, "MMMM") }}
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import dayjs from "dayjs"

import { toDate } from "@/lib/date-utils"
import { isPresent } from "@/lib/utils"

import Collection from "@/components/Collection"
import EventOccurrenceDate from "@/components/collection-item/EventOccurrenceDate"

export default {
  props: {
    active: { type: Boolean, default: false }
  },

  components: {
    Collection,
    EventOccurrenceDate
  },

  data() {
    return {
      isLoading: false,
      monthsFromNow: 0,
      eventsByDay: {},
      currentEvent: null
    }
  },

  mounted() {
    this.fetchEvents()
  },

  watch: {
    monthsFromNow() {
      this.fetchEvents()
    }
  },

  computed: {
    shownDate() {
      return dayjs().add(this.monthsFromNow, "month")
    },

    start() {
      return this.shownDate.startOf("month").format()
    },

    end() {
      return this.shownDate.endOf("month").format()
    },

    currentEventId() {
      return this.$route.query.event_id
    }
  },

  methods: {
    toDate,
    isPresent,

    ...mapActions("events", ["fetchEventsForPeriod"]),

    change(n) {
      this.monthsFromNow += n
    },

    jumpToToday() {
      this.monthsFromNow = 0
    },

    unchooseEvent() {
      this.eventId = null

      this.$router.replace({
        ...this.$router.currentRoute,
        query: { event_id: undefined }
      })

      this.fetchEvents()
    },

    fetchEvents() {
      this.isLoading = true

      this.fetchEventsForPeriod({
        start: this.start,
        end: this.end,
        eventId: this.currentEventId
      })
        .then(res => {
          this.eventsByDay = res.data.event_occurrences
          this.currentEvent = res.data.event
        })
        .finally(() => (this.isLoading = false))
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.event-schedule__day {
  display: grid;
  grid-template-columns: $size--10 auto;
  align-content: flex-start;
  opacity: 0;
  animation: fade-in-up 0.24s ease forwards;
}

.event-schedule__date-wrapper {
  height: 5rem;
}

.event-schedule__header {
  .v-button {
    color: $color-ui--grey-50;
  }
}
.event-schedule__current-event {
  background-color: $color-ui--grey-20;
  display: flex;
  align-items: center;
  padding-left: $size--4;
  border-radius: var(--border-radius);

  .v-button {
    font-size: 1.5em;
    margin-left: auto;
  }

  .event-schedule__current-event-title {
    font-weight: $font-weight--semi-bold;
    padding-top: $size--2;
    padding-bottom: $size--2;
    font-size: $font-size--base;
  }
}

.event-schedule__nav-button {
  margin: 0 $size--1;

  .v-icon {
    font-size: $size--8;
  }
}

.v-button.event-schedule__jump-to-today {
  margin-right: -$size--3;

  .v-icon {
    font-size: $size--5;
    top: 2px;
  }
}
</style>
